import type { ReactNode } from 'react';

export const symbol_cases: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-80q-24 0-42-18t-18-42v-429q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v429h579q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q691.75-80 679-80H100Zm120-120q-24 0-42-18t-18-42v-488q0-12.75 8.63-21.38Q177.25-778 190-778h212v-82q0-24 18-42t42-18h156q24 0 42 18t18 42v82h212q12.75 0 21.38 8.62Q920-760.75 920-748v488q0 24-18 42t-42 18H220Zm0-60h640v-458H220v458Zm242-518h156v-82H462v82ZM220-260v-458 458Z"
		/>
	</svg>
);
